/***
 * Created on 2024/11/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useRef} from 'react';
import ModalComponent from "../../common/ModalComonent/ModalComponent";
import {useTranslation} from "react-i18next";
import {get_primary_email} from "../../../service/common";

function DeviceTransferToQidFail({openModal, closeModal, dispatch, state}) {
    const { t } = useTranslation();
    const currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
    const email = get_primary_email(currentUser);
    const ref = useRef(null);

    useEffect(() => {
        ref?.current?.setShowSubmit(false);
        ref?.current?.setCancelText(t('@OK@'));
    }, []);

    return (
        <ModalComponent title={t('@Transfer Incomplete@')} isOpen={openModal} onClose={closeModal} ref={ref}>
            <div className="dialog-content">
                <div className="text-wrap !mb-24">
                    {t('@The transfer of your device {{device_name}} from the {{org_name}} to QID {{qid_email}} was not completed due to an error. To complete the transfer, please go to the QNAP device, open the myQNAPcloud App, and manually initiate the transfer process from there by clicking the switch icon.@',
                        {device_name: state?.device_data?.device_name, org_name: state?.organization?.name, qid_email: email})}
                </div>
            </div>
        </ModalComponent>
    );
}

export default DeviceTransferToQidFail;